import { Component } from 'react';
import PropTypes from 'prop-types';
import TableActions from 'portaltransparencia-common/components/TableActions.react';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import React from 'react';
import { connect } from 'react-redux';
import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react.js';

export class ResumoRendimentosServidores extends Component {
  static propTypes = {
    totaisRendimentos: PropTypes.object
  };

  renderDadosFinanceiros = item => {
    if (!item.get('tipoFolha')) {
      return null;
    }

    const key = item.get('tipoFolha');
    const rendimentos =
      item.get('vencimentos') == null ? 0 : item.get('vencimentos');
    const descontos = item.get('descontos') == null ? 0 : item.get('descontos');

    return (
      <TableActions ref="row" key={key} data={item}>
        <td>{item.get('descricaoTipoFolha')}</td>
        <td className="right">
          <NumberFormatter value={rendimentos} />
        </td>
        <td className="right">
          <NumberFormatter value={descontos} />
        </td>
        <td className="right">
          <NumberFormatter value={rendimentos - descontos} />
        </td>
      </TableActions>
    );
  };

  render() {
    const { totaisRendimentos } = this.props;

    if (totaisRendimentos.isEmpty()) {
      return null;
    }

    const totalVencimentos = this.calcularTotal(
      totaisRendimentos,
      'vencimentos'
    );
    const totalDescontos = this.calcularTotal(totaisRendimentos, 'descontos');

    const totalLiquido = totalVencimentos - totalDescontos;

    return (
      <div className="panel-table-outer">
        <table className="panel-table striped fancy">
          <TableHeader empty={totaisRendimentos.isEmpty()}>
            <tr>
              <th>Tipo de Folha</th>
              <th className="right">Proventos</th>
              <th className="right">Descontos</th>
              <th className="right">Líquido</th>
              <th></th>
            </tr>
          </TableHeader>
          <tbody>{totaisRendimentos.map(this.renderDadosFinanceiros)}</tbody>
          <tfoot>
            <tr>
              <td />
              <td className="right">
                <i>Total Proventos:</i>
                <br />
                <NumberFormatter value={totalVencimentos} />
              </td>
              <td className="right">
                <i>Total Descontos:</i>
                <br />
                <NumberFormatter value={totalDescontos} />
              </td>
              <td className="right">
                <i>Total Líquido:</i>
                <br />
                <NumberFormatter value={totalLiquido} />
              </td>
              <td />
            </tr>
          </tfoot>
        </table>
      </div>
    );
  }

  calcularTotal = (lista, campo) =>
    lista.reduce((acc, item) => acc + (Number(item.get(campo)) || 0), 0);
}

export default connect()(ResumoRendimentosServidores);
